import { render, staticRenderFns } from "./ChatNotificationsConfig.vue?vue&type=template&id=1a822590&"
import script from "./ChatNotificationsConfig.vue?vue&type=script&lang=js&"
export * from "./ChatNotificationsConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports